import api from "../../api/axios.config";
import { setDataTermsConditions } from "../slices/termsAndConditions/termsAndConditionsSlice";

export const getTermsAndConditions = (type) => {
    return async (dispatch, getState) => {
        const result = await api.get(`/api/terms-conditions/${type}`);
        dispatch(setDataTermsConditions(result.data.data));
    }
}